export const validateForm = (form) => {
    const errors = {};

    // Upewnij się, że `form` to HTMLFormElement
    if (!(form instanceof HTMLFormElement)) {
        throw new Error("Argument nie jest poprawnym elementem HTMLFormElement.");
    }

    // Pobierz wszystkie wartości z formularza
    const formData = new FormData(form);

    // Walidacja pola "Imię i nazwisko"
    const nameSurname = formData.get('name_surname');
    if (!nameSurname || nameSurname.trim() === '') {
        errors.name_surname = 'Pole jest wymagane';
    }

    // Walidacja pola "Telefon"
    const phone = formData.get("phone");
    if (!phone || !/^\d{9,12}$/.test(phone.trim())) {
        errors.phone = "Telefon musi zawierać od 9 do 12 cyfr.";
    }

    // Walidacja pola "Email"
    const email = formData.get("email");
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
        errors.email = "Podaj poprawny adres email.";
    }

    // Walidacja pola "Opis projektu"
    const projectDescription = formData.get("project_description");
    if (!projectDescription || projectDescription.trim().length === 0) {
        errors.project_description = "Opis projektu jest wymagany.";
    }

    // Walidacja pola select "Typ projektu"
    const projectType = formData.get("project_type");
    if (!projectType || projectType === "") {
        errors.project_type = "Wybierz typ projektu.";
    }

    // Walidacja pola select "Budżet"
    const budget = formData.get("budget");
    if (!budget || budget === "") {
        errors.budget = "Wybierz orientacyjny budżet.";
    }

    // Walidacja radio "Materiały bazowe"
    const baseMaterials = formData.get("base_materials");
    if (!baseMaterials) {
        errors.base_materials = "Wybierz, czy posiadasz materiały bazowe.";
    }

    // Walidacja radio "Projekt graficzny"
    const graphicDesign = formData.get("graphic_design");
    if (!graphicDesign) {
        errors.graphic_design = "Wybierz, czy posiadasz gotowy projekt graficzny.";
    }

    return errors;
};
